"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Default", {
  enumerable: true,
  get: function get() {
    return _Default["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook["default"];
  }
});
Object.defineProperty(exports, "FacebookMessenger", {
  enumerable: true,
  get: function get() {
    return _FacebookMessenger["default"];
  }
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _Instagram["default"];
  }
});
Object.defineProperty(exports, "Mail", {
  enumerable: true,
  get: function get() {
    return _Mail["default"];
  }
});
Object.defineProperty(exports, "Sms", {
  enumerable: true,
  get: function get() {
    return _Sms["default"];
  }
});
Object.defineProperty(exports, "Telegram", {
  enumerable: true,
  get: function get() {
    return _Telegram["default"];
  }
});
Object.defineProperty(exports, "TelegramWithoutBg", {
  enumerable: true,
  get: function get() {
    return _TelegramWithoutBg["default"];
  }
});
Object.defineProperty(exports, "Viber", {
  enumerable: true,
  get: function get() {
    return _Viber["default"];
  }
});
Object.defineProperty(exports, "Vk", {
  enumerable: true,
  get: function get() {
    return _Vk["default"];
  }
});
Object.defineProperty(exports, "Whatsapp", {
  enumerable: true,
  get: function get() {
    return _Whatsapp["default"];
  }
});
Object.defineProperty(exports, "YouTubeLogo", {
  enumerable: true,
  get: function get() {
    return _YouTubeLogo["default"];
  }
});
var _Default = _interopRequireDefault(require("./Default"));
var _Facebook = _interopRequireDefault(require("./Facebook"));
var _FacebookMessenger = _interopRequireDefault(require("./FacebookMessenger"));
var _Instagram = _interopRequireDefault(require("./Instagram"));
var _Mail = _interopRequireDefault(require("./Mail"));
var _Sms = _interopRequireDefault(require("./Sms"));
var _TelegramWithoutBg = _interopRequireDefault(require("./TelegramWithoutBg"));
var _Telegram = _interopRequireDefault(require("./Telegram"));
var _Viber = _interopRequireDefault(require("./Viber"));
var _Vk = _interopRequireDefault(require("./Vk"));
var _Whatsapp = _interopRequireDefault(require("./Whatsapp"));
var _YouTubeLogo = _interopRequireDefault(require("./YouTubeLogo"));